/* TODO: t() */
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { Text, TextInput } from '../../../uiold';
import { themeColors } from '../../../uiold/Constants';
import { useEditorState } from '../../EditorContext';

import { TextInputElementDefinition } from '../../../../types/shared/EvaluationForm';
import { FormElementProps } from '../../types';

type Props = FormElementProps<TextInputElementDefinition>;
function TextInputElementEditView(props: Props) {
  let { definition, style, sortIndex } = props;

  let { register, submission } = useEditorState();
  let answer = submission && submission.fields[sortIndex];
  let [value, setValue] = useState(answer?.value || '');

  return (
    <View style={[styles.root, style]}>
      <Text style={styles.question}>{definition.question}</Text>
      <TextInput
        name={definition.id}
        ref={(e) => e && register(e.getNativeHandle())}
        style={styles.answer}
        value={typeof value === 'string' ? value : ''}
        onChangeText={(value) => setValue(value)}
      />
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    padding: 16,
    backgroundColor: themeColors.white,
  },
  question: {
    marginBottom: 8,
  },
  answer: {
    // Bootstrap CSS is overriding this font size for text input.
    fontSize: 14,
  },
});

export default TextInputElementEditView;
